import {twMerge} from "tailwind-merge";
import {useState} from "react";

export default function SimpleDropdown({activeItem = {}, texts = {}, classes = {}, options = [], onChange}) {

    const [showDropdown, setShowDropdown] = useState(false);

    const {labelClasses = "", triggerClasses = "", parentClasses= "", dropdownClasses = ""} = classes;
    const {label = "", placeholder = "انتخاب کنید"} = texts;

    const changeHandler = (item) => {
        setShowDropdown(false);
        onChange(item);
    }

    return (
        <div className={twMerge("relative", parentClasses)}>
            <p className={twMerge("text-pol-gray-600 text-sm mb-2.5 mr-2.5", labelClasses)}>{label}</p>
            <div className="relative">
                <button
                    onClick={() => setShowDropdown(true)}
                    className={twMerge("w-full rounded-2xl border border-pol-gray-light-3 bg-pol-light-7 px-4 py-3.5 flex items-center justify-between text-pol-dark-800", triggerClasses)}>
                    <span>{activeItem.name ? activeItem.name : placeholder}</span>
                    <i className="icon-simple-arrow-left -rotate-90 text-xs"/>
                </button>

                <ul className={twMerge(`absolute z-20 space-y-2 text-sm text-pol-dark-800 w-full max-h-[300px] overflow-y-auto bg-white top-0 border border-pol-gray-light-3 rounded-2xl px-4 py-3.5 ${showDropdown ? "" : "hidden"}`, dropdownClasses)}>
                    {
                        options.map(item => (
                            <li key={item.value}
                                className={item.value === activeItem.value ? "text-pol-blue" : ""}>
                                <button
                                    className="w-full text-right"
                                    onClick={() => changeHandler(item)}>{item.name}</button>
                            </li>
                        ))
                    }
                </ul>
            </div>

            {
                showDropdown ?
                    <div className="fixed z-10 top-0 left-0 w-full h-full" onClick={() => setShowDropdown(false)}/>
                    : null
            }
        </div>
    )
}
